// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_iu-0";
export var fulfillmentPanelBody = "_iu-1";